<script setup>
  import SharePane from "@/components/Survey/Share/SharePane.vue";

  defineProps({
    survey: { type: Object, required: true },
  });
</script>

<template>
  <div
    data-cy="survey-links-page"
    class="px-4 py-6">
    <div class="mx-auto w-full max-w-4xl">
      <SharePane :survey="survey" />
    </div>
  </div>
</template>
